// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-content {\n  --padding-start: 16px;\n  --padding-end: 16px;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/terms/terms.page.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,mBAAA;AACF","sourcesContent":["ion-content {\r\n  --padding-start: 16px;\r\n  --padding-end: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
